import * as Yup from "yup";
import { createNewTicketService } from "../../services/ticketsServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    customer: [],
    send_to_all: false,
    subject: "",
    context: ""
};

export const onSubmit = async (values, actions) => {
    const { customer, ...data } = values;
    try {
        const response = await createNewTicketService(values.send_to_all ? data : values);
        if (response.status === 200) {
            Alert("انجام عملیات", "تیکت با موفقیت ارسال شد", "success");
            actions.resetForm();
        }
    } catch (error) {
        
    }
}

export const validationSchema = Yup.object().shape({
    customer: Yup.array().when("send_to_all", {
        is: false,
        then: (schema) => schema.min(1, "لطفاً حداقل یک گیرنده انتخاب کنید")
    }),
    send_to_all: Yup.boolean(),
    subject: Yup.string().required("لطفاً عنوان تیکت را وارد کنید"),
    context: Yup.string().required("لطفاً متن تیکت را وارد کنید"),
});